import {
	OP_Container,
	OR_BlockText,
	OR_Description,
	OR_LeftBlock,
	OR_RightBlock,
	OR_TextBlock,
	OR_Title,
} from "../OrderPages.styled";
import { Button } from "../../../components/common";
import { ButtonSize } from "../../../constants";
import { useNavigate } from "react-router-dom";

interface OrderSuccessPageProps {}

export const OrderFailPage = ({}: OrderSuccessPageProps) => {
	const navigate = useNavigate();

	const handleOnToSubscriptions = () => {
		navigate("/cabinet/subscriptions-plans");
	};

	return (
		<OP_Container>
			<OR_LeftBlock>
				<OR_TextBlock>
					<OR_Title>Payment failed</OR_Title>
					<OR_Description>Your payment could not be completed.</OR_Description>
				</OR_TextBlock>
			</OR_LeftBlock>

			<OR_RightBlock>
				<OR_BlockText>
					Unfortunately, we were unable to process your payment. Please check your payment details or try using another
					payment method.
				</OR_BlockText>

				<OR_BlockText>
					No active subscription has been added to your account. You can return to the subscription plans page and try
					again.
				</OR_BlockText>

				<Button size={ButtonSize.SMALL} onClick={handleOnToSubscriptions}>
					Try Again
				</Button>
			</OR_RightBlock>
		</OP_Container>
	);
};
